import { css } from '@emotion/core';

// eslint-disable-next-line import/prefer-default-export
export const singleOperationSwagger = css`
  .swagger-ui .opblock-tag {
    display: none;
  }
`;

export const multiOperationSwagger = css``;
